import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV4 } from "@/endpoints/m2m-cleaning.cleaner-v4"
import { DateString } from "@/utils/dateString"
import { SimpleCleaning } from "@/model/simpleCleaning"

type SimpleCleaningsByDatesOutput = Record<DateString, SimpleCleaning[]>

export const useSimpleCleaningsByDates = (dates: DateString[]) => {
    const { token } = useAuth()
    const endpoint = m2mCleaning_cleanerV4.findCleaningsByDates
    return useAuthBearerFetch<SimpleCleaningsByDatesOutput>(token, endpoint(), {
        method: endpoint.method,
        body: JSON.stringify(dates)
    })
}
